import { supabase } from "@/integrations/supabase/client";

export type EmailTemplate =
  | "welcome"
  | "password-reset"
  | "subscription-confirmed"
  | "subscription-cancelled"
  | "subscription-renewal-reminder"
  | "payment-failed"
  | "password-changed"
  | "email-changed"
  | "watch-schedule-generated"
  | "watch-schedule-daily-pick"
  | "movie-night-invite"
  | "movie-night-results"
  | "monthly-refresh";

export interface SendEmailArgs {
  templateName: EmailTemplate;
  recipientEmail: string;
  templateData?: Record<string, unknown>;
  idempotencyKey?: string;
}

/**
 * Fire-and-forget transactional email send. Failures are logged but never thrown
 * to the caller — emails should never block the UX.
 */
export async function sendAppEmail(args: SendEmailArgs): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke("send-email", { body: args });
    if (error) console.warn("[sendAppEmail]", args.templateName, error);
  } catch (err) {
    console.warn("[sendAppEmail] failed", args.templateName, err);
  }
}
